import {TextField} from '@material-ui/core'
import React from 'react'
import {Controller, FieldValues} from 'react-hook-form'

import {handleNoSpecialCharacters} from '../../../../common/utils/handleNoSpecialCharacters'
import {useTranslation} from '../../../../hooks/useTranslation'
import {UserInformationInputSkeleton} from '../../Skeleton/UserInformationInputSkeleton'
import {UserInformationProps} from '../types'
import {useStyles} from '../UserInput.styles'

export const UserNameInput = <T extends FieldValues>({
  readonlyMode,
  formMethods,
  isLoading,
  isQuickPreview,
  name
}: UserInformationProps<T>) => {
  const {t} = useTranslation()
  const errors = formMethods.formState.errors
  const touched = formMethods.formState.touchedFields
  const classes = useStyles()

  if (isLoading) {
    return <UserInformationInputSkeleton />
  }

  return (
    <Controller
      name={name}
      control={formMethods.control}
      rules={{
        validate: (value) => handleNoSpecialCharacters(value, t)
      }}
      render={({field}) => (
        <TextField
          {...field}
          data-test-id={`userInformationForm-${field.name}`}
          className={isQuickPreview ? classes.quickPreviewTextField : classes.textField}
          fullWidth
          label={t('userInformationForm.name')}
          autoComplete="name"
          margin="normal"
          error={touched['name'] && !!errors.name}
          helperText={errors?.[name]?.message as string}
          style={{maxWidth: isQuickPreview ? undefined : 400}}
          InputLabelProps={{shrink: true}}
          InputProps={{readOnly: readonlyMode, disableUnderline: readonlyMode || isQuickPreview}}
        />
      )}
    />
  )
}
